module.exports = __webpack_public_path__ + "img/work.5a67a65c.png";